var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Edit your List")]),_c('ChecklistCreateForm',{attrs:{"id":this.$route.params.id,"slug":this.$route.params.slug}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }